import { Injectable } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Form, FormFactory } from '@ubud/form';
import { RegisterInstitutionCommunityRule } from '../rules/register-institution-community.rule';

@Injectable()
export class RegisterInstitutionCommunityFormFactory implements FormFactory {
    public constructor(private fb: FormBuilder) {}

    public create(): Form {
        const formRule = new RegisterInstitutionCommunityRule();

        return {
            formGroup: this.fb.group(formRule.getFormControls()),
            rules: [formRule],
        };
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/factories/register-institution-community-form.factory.ts